


































































import { updateData } from '@/services/service'
import { ICategory } from '@/types/category'
import Vue from 'vue'
import chrome from 'vue-color/src/components/Chrome.vue'

import {ElMessageBoxOptions} from 'element-ui/types/message-box'
import {MessageType} from 'element-ui/types/message'

interface IRefs {
    descViewMode: HTMLFormElement
}

export default Vue.extend({
    data() {
        return {
            catColor: this.color as string,
            descInputHeight: {},
            isColorEditMode: false as boolean,
            isEditMode: false as boolean,
            isHidden: true as boolean,
            isMarkEditMode: false as boolean,
            isPalleteToBeClosed: false,
        }
    },
    components: {
        'chrome-picker': chrome,
    },
    mounted() {
        if (!this.isEditMode) {
            const FormEl = this.$refs.descViewMode as HTMLElement
            const FormHeight = FormEl.clientHeight
        }
    },
    methods: {
        updateData,
        toggleTools(e?: MouseEvent): boolean | void {
            if (!this.isColorEditMode && !this.isEditMode) {
                return this.isHidden = !this.isHidden
            }
        },
        toggleView(): void | boolean {
            // set height for textearea element
            if (window.innerWidth < 768) {
                return false
            }

            // set description textearea height
            if (this.$refs.descViewMode) {
                const FormEl = this.$refs.descViewMode as HTMLElement
                const FormHeight = FormEl.clientHeight

                this.$set(this.descInputHeight, 'height', FormHeight + 25 + 'px')
            }

            this.isEditMode = !this.isEditMode

            // save on enter
            if (this.isEditMode) {
                document.addEventListener('keydown', this.saveOnEnter)
            } else {
                document.removeEventListener('keydown', this.saveOnEnter)
            }
        },
        saveOnEnter(e: KeyboardEvent): void {
            if (e.keyCode === 13) {
                this.isEditMode = false
            }
        },
        alert() {
            const that = this

            const alertMessage = this.$t('deleteCategoryWarning') as string
            const alertHeader = this.$t('warning') as string
            const cancelBtnMsg = this.$t('cancel') as string

            const options: ElMessageBoxOptions = {
                cancelButtonText: cancelBtnMsg,
                confirmButtonText: 'OK',
                type: 'warning' as MessageType,
            }

            // @ts-ignore
            this.$confirm(alertMessage, alertHeader, options)
            .then(() => {
                that.deleteCategory()
            })
            .catch(() => {})
        },
        deleteCategory(): void {
            this.$store.commit('deleteCategory', this.id)
        },
        toggleColorPicker(e: MouseEvent): boolean {
            this.isPalleteToBeClosed = false
            return this.isColorEditMode = !this.isColorEditMode
        },
        updateColor(value: { hex: string }): void {
            // hack: fixing - catColor model gets object on click, not store value
            this.catColor = value.hex

            updateData(value.hex, this.id, 'color')
        },
        closePallete(): void {
            this.isColorEditMode = false
            this.isHidden = true
        },
    },
    name: 'Category',
    props: [
        'name',
        'description',
        'mark',
        'id',
        'color',
    ],
})
